module.exports = __webpack_public_path__ + "images/assets/72ecd747f75a7ddaff7713fdcb21f8e4.svg";